import React, { FC, useEffect, useState } from 'react';

import s from './DesktopApp.scss';

import * as BIManager from '../../utils/bi';
import { fedopsLogger } from '../../utils/fedops-logger';

import { InfoPopUp } from '../InfoPopUp/InfoPopUp';
import { TemplateDemo } from '../TemplateDemo/TemplateDemo';
import { ToolBar } from '../ToolBar/ToolBar';
import { WixStudioToolBar } from '../partials/WixStudioNewToolBar/WixStudioToolBar';
import { WixStudioTemplateDemo } from '../WixStudioTemplateDemo/WixStudioTemplateDemo';

import { useTemplateContext } from '../../context/TemplateContext/TemplateContext';
import { useUIContext } from '../../context/UIContext/UIContext';
import { desktopAppDataHooks } from './DesktopApp.dataHooks';
import { TemplateModal } from '../TemplateModal';
import { useUserData } from '../../context/UserDataContext/UserDataContext';

export const DesktopApp: FC<{ dataHook?: string }> = ({ dataHook }) => {
  const { viewMode, toggleViewMode, isInfoShown } = useUIContext();
  const { template } = useTemplateContext();
  const { isStudio, desktop16X9Image, editorUrl } = template;
  const userData = useUserData();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isModalShown = !!Number(window?.localStorage?.getItem?.('newEditModal'));
    const isWixelDashboard = new URLSearchParams(window?.location?.search).get('sourceContext') === 'wixelDashboard';
    if (!isOpen && !isModalShown && !isWixelDashboard) {
      window?.localStorage?.setItem?.('newEditModal', '1');
      const t = setTimeout(() => setIsOpen(true), userData.isLoggedIn ? 1000 : 8000);
      return () => {
        clearTimeout(t);
      };
    }
  }, [isOpen, userData.isLoggedIn]);

  useEffect(() => {
    BIManager.reportLoadSuccess();
    fedopsLogger.appLoaded();
  }, []);

  useEffect(() => {
    document.getElementsByTagName('body')[0].classList.toggle('popup', isInfoShown);
  }, [isInfoShown]);

  return (
    <div data-hook={dataHook}>
      {isStudio ? (
        <div className={s.studioRoot}>
          <WixStudioToolBar
            viewMode={viewMode}
            toggleViewMode={toggleViewMode}
            dataHook={desktopAppDataHooks.wixStudioNewToolbar}
          />
          <WixStudioTemplateDemo viewMode={viewMode} dataHook={desktopAppDataHooks.wixStudioTemplateDemo} />
        </div>
      ) : (
        <>
          <ToolBar dataHook={desktopAppDataHooks.toolBar} />
          <TemplateDemo dataHook={desktopAppDataHooks.templateDemo} />
          <InfoPopUp dataHook={desktopAppDataHooks.infoPopUp} />
        </>
      )}
      {isOpen && (
        <TemplateModal editorUrl={editorUrl} isOpen image={desktop16X9Image} onClose={() => setIsOpen(false)} />
      )}
    </div>
  );
};
